import { getNeighborhoodCenter } from "../../utils/geoDecisionEngine";
import {
  FALLBACK_MAP_CENTER,
  getCityCenter,
  normalizeCityName,
} from "../../utils/cityCenters";

export function buildCityFocusKey(
  city?: string | null,
  uf?: string | null
): string | null {
  if (!city?.trim()) {
    return null;
  }

  const normalizedUf = uf?.trim().toUpperCase() ?? "";
  return `${normalizeCityName(city)}|${normalizedUf}`;
}

export function resolveInitialMapCenter(
  neighborhood?: string | null,
  city?: string | null,
  uf?: string | null
): { lat: number; lng: number } {
  if (neighborhood) {
    const neighborhoodCenter = getNeighborhoodCenter(neighborhood);
    if (neighborhoodCenter) {
      return neighborhoodCenter;
    }
  }

  return getCityCenter(city, uf) ?? FALLBACK_MAP_CENTER;
}

export function shouldFocusMapOnCity({
  isMapLoaded,
  preferRestoredView,
  neighborhood,
  city,
  previousCityKey,
  uf,
}: {
  isMapLoaded: boolean;
  preferRestoredView: boolean;
  neighborhood?: string | null;
  city?: string | null;
  previousCityKey: string | null;
  uf?: string | null;
}): { shouldFocus: boolean; cityKey: string | null } {
  const cityKey = buildCityFocusKey(city, uf);

  if (!isMapLoaded || preferRestoredView || neighborhood || !cityKey) {
    return { shouldFocus: false, cityKey };
  }

  if (previousCityKey === cityKey) {
    return { shouldFocus: false, cityKey };
  }

  return { shouldFocus: true, cityKey };
}

export function shouldRestoreSavedMapView({
  preferRestoredView,
  hasRestored,
  hasNeighborhood,
  hasSavedView,
}: {
  preferRestoredView: boolean;
  hasRestored: boolean;
  hasNeighborhood: boolean;
  hasSavedView: boolean;
}): boolean {
  return preferRestoredView && hasSavedView && !hasRestored && !hasNeighborhood;
}
